import { Link } from "react-router-dom";

export default function ServiceFeatureCard({
  title,
  image,
  description,
  link,
  className = "",
}) {
  return (
    <div
      className={`relative rounded-2xl overflow-hidden shadow-md group hover:shadow-2xl transition-all duration-500 h-full ${className}`}
    >
      {/* Image always fills */}
      <img
        src={image}
        alt={title}
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        loading="eager"
        fetchPriority="high"
        decoding="sync"
      />

      {/* Overlay only for text */}
      <div className="absolute inset-0 bg-black/40 group-hover:bg-black/70 transition duration-500 flex flex-col justify-end p-4 sm:p-6">
        <h2 className="text-white text-base sm:text-lg md:text-xl font-semibold mb-2">
          {title}
        </h2>

        <p className="text-white text-xs sm:text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500">
          {description}
        </p>

        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500 mt-3 sm:mt-4">
          <Link
            to={link}
            className="inline-block px-3 sm:px-4 py-2 text-xs sm:text-sm bg-white text-blue-600 font-semibold rounded-lg hover:bg-purple-100 transition"
          >
            Reach Out Now
          </Link>
        </div>
      </div>
    </div>
  );
}
